module.exports = __webpack_public_path__ + "img/brava.e733ac8e.png";